import { PlayBox } from "@/modules/play/Components";
import SynthesisRecapForPlayer from "@/modules/play/Components/Synthesis/SynthesisRecapForPlayer";
import { useCurrentPlayer } from "@/modules/play/context/hooks/player";

export { SynthesisGeneralTab };

function SynthesisGeneralTab() {
  const { team } = useCurrentPlayer();

  return (
    <PlayBox display="flex" flexDirection="column" gap={4}>
      <SynthesisRecapForPlayer team={team} />
    </PlayBox>
  );
}
